export const storeName = 'welcomePage';

export const welcomePageSelector = state => ({ ...state[storeName] });
